package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class AssignTicketResponseDto(
    val ticketId: String,
    val assignedToAccountUserId: String,
    val assignedAt: String,
    val changed: Boolean
)

@Serializable
data class AssignTicketErrorDto(
    val error: String,
    @kotlinx.serialization.SerialName("assigned_to_account_user_id") val assignedToAccountUserId: String,
    @kotlinx.serialization.SerialName("assigned_to_display_name") val assignedToDisplayName: String
)

@Serializable
data class UnassignTicketResponseDto(
    val ticketId: String,
    val changed: Boolean
)

@Serializable
data class AssignUpToResponseDto(
    val assigned: List<AssignTicketResponseDto>
)
